/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Message list support stuff

namespace('Slzr', function(exports, top) {
  const $ = Slzr.jQuery;

  return exports.MessageList = class MessageList {
    constructor(options) {
      const defaults = {
        // URL to ping to mark an item as read (null disables)
        setReadURL: null,
        // Container selector or element of item listings
        container: null,
        // Support ajax replacement of container
        isAjaxed: false
      };

      this.options = $.extend({}, defaults, options);
      this.container = $(this.options.container);
      this.selector = `#${this.container[0].id} *`;

      this.container.on('click.MessageList', 'h3 a[data-action="expand"]', ev => this.messageListClicked(ev));
    }

    bodyClicked(ev) {
      const el = $(ev.target);

      if (el.is(this.selector)) {
        return this.messageListClicked(ev);
      }

      return true;
    }

    messageListClicked(ev) {
      const el = $(ev.target);

      const message_item = el.hasClass('manage_item') ? el : el.closest('div.manage_item');
      if (!message_item) { return; }

      // Toggle expanded state
      if (message_item.hasClass('expanded')) {
        this.collapseItem(message_item);
      } else {
        this.container
          .find('div.manage_item.expanded')
          .each((i, el) => this.collapseItem(el));

        this.expandItem(message_item);
      }

      return false;
    }

    setReadState(id) {
      if (this.options.setReadURL) {
        return $.post(this.options.setReadURL, {id});
      }
    }

    showActionButtons(el) {
      const message_el = $(el).closest('div.manage_item');
      return message_el.find('div.action_buttons.form_trigger').show();
    }

    hideActionButtons(el) {
      const message_el = $(el).closest('div.manage_item');
      return message_el.find('div.action_buttons.form_trigger').hide();
    }

    showReply(el) {
      const message_el = $(el).closest('div.manage_item');
      this.hideForward(el);
      this.hideActionButtons(el);
      return $('form.reply_form', message_el).show();
    }

    hideReply(el) {
      return $(el).closest('div.manage_item').find('form.reply_form').hide();
    }

    showForward(el) {
      const message_el = $(el).closest('div.manage_item');
      this.hideReply(el);
      this.hideActionButtons(el);
      return $('form.forward_form', message_el).show();
    }

    hideForward(el) {
      return $(el).closest('div.manage_item').find('form.forward_form').hide();
    }

    cancelEdit(el) {
      this.hideForward(el);
      this.hideReply(el);
      return this.showActionButtons(el);
    }

    cancelCompose(el) {
      $('#x-compose-form')
        .hide()
        .prevAll('.link_action')
        .show();
      return this.clearCompose();
    }

    composeMessage(el) {
      return $('#x-compose-form')
        .show()
        .prevAll('.link_action')
        .hide();
    }

    clearCompose() {
      return $('#x-compose-form').find('select, textarea, input[type="text"]').val('');
    }

    expandItem(message_item) {
      const $message_item = $(message_item);

      $('div.details, img.icon_small', message_item).show();
      $('img.icon_tiny, .preview_text', message_item).hide();
      $message_item.addClass('expanded');
      if ($message_item.hasClass('unread') || ($message_item.find('.unread').length > 0)) { this.setReadState($message_item.attr('id')); }
      $message_item.removeClass('unread');
      return $('.unread', message_item).removeClass('unread');
    }

    collapseItem(message_item) {
      $('div.details, img.icon_small', message_item).hide();
      $('img.icon_tiny, .preview_text', message_item).show();
      return $(message_item).removeClass('expanded');
    }
  };
});
